import * as api from "@/api/stationAutoDj.api"

let autoDjRequest = 0

export const fetchAutoDj = async ({ commit }, stationKey) => {
  const request = ++autoDjRequest
  const autoDj = await api.getAutoDj(stationKey)

  if (request === autoDjRequest) {
    commit("setAutoDj", autoDj)
    commit("setStationKey", stationKey)
  }
}

export const reorderPlaylist = async ({ commit, state }, { stationKey, references }) => {
  await api.updatePlaylistTracksOrder(stationKey, references)

  if (state.stationKey === stationKey) {
    commit("setPlaylist", references)
  }
}

export const changePreviewURL = async ({ commit }, url) => {
  commit("setPreviewURL", url)
}

export const shufflePlaylist = async ({ commit, state }, { stationKey, shuffle }) => {
  await api.updatePlaylistShuffle(stationKey, shuffle)

  if (state.stationKey === stationKey) {
    commit("setShuffle", shuffle)
  }
}

export const fetchCurrentlyPlaying = async ({ commit, state }, stationKey) => {
  const current = await api.getCurrentlyPlaying(stationKey)

  if (state.stationKey === stationKey) {
    commit("setCurrent", current)
  }
}

export const deleteTracks = async (vuex, { stationKey, references }) => {
  await api.deletePlaylistTracks(stationKey, references)

  if (vuex.state.stationKey !== stationKey) {
    return
  }

  const playlist = vuex.state.autoDj.playlist.filter((reference) => !references.includes(reference))

  vuex.commit("setPlaylist", playlist)
}

export const addPlaylistReferences = async ({ state, commit }, references) => {
  commit("setPlaylist", state.autoDj.playlist.concat(references))
}
